export const PC_COCKPIT_REDIRECT_ROUTE_STORAGE_KEY =
  'pc-cockpit-redirect-route';
